import { Pricescheme, Pricesection, PricesectionPriceage } from "@types";

export default function calculatePriceRange(
  priceschemes: Pricescheme[],
  ids?: {
    pricesectionIds?: number[];
    groupedPricesectionIds?: number[];
  }
) {
  const { pricesectionIds, groupedPricesectionIds } = ids || {};
  const prices: number[][] = [];

  function processPriceItem(priceItem: number) {
    if (priceItem === 0) return;

    if (!prices[Math.floor(priceItem)]) {
      prices[Math.floor(priceItem)] = [];
    }

    if (!prices[Math.floor(priceItem)].includes(priceItem)) {
      prices[Math.floor(priceItem)][
        parseInt(priceItem.toFixed(2).split(".")[1])
      ] = priceItem;
    }
  }

  function processPriceage(priceage: PricesectionPriceage) {
    if (priceage.active && priceage.type === "standard") {
      processPriceItem(priceage.price.price);
    }
  }

  function processPricesection(pricesection: Pricesection) {
    if (!pricesection.active) return;

    // if array of pricesection ids is given, we are getting the price range of the "extra add ons"
    if (pricesectionIds && pricesectionIds.length > 0) {
      pricesection.priceages?.forEach((priceage) => {
        if (priceage.active && priceage.type === "extra") {
          processPriceItem(priceage.price.price);
        }
      });
      return;
    }
    if (groupedPricesectionIds) {
      if (groupedPricesectionIds.includes(pricesection.id)) {
        pricesection.manualprices
          ?.filter(
            (manualprice) =>
              manualprice.active &&
              !manualprice.isExtra &&
              manualprice.showInPriceRange
          )
          .forEach((manualprice) => {
            processPriceItem(manualprice.price);
          });

        const standard_priceages = pricesection.priceages
          ? pricesection.priceages.filter(
              (priceage) => priceage.active && priceage.type === "standard"
            )
          : [];

        if (standard_priceages.length === 0) {
          pricesection.priceages
            ?.filter((priceage) => priceage.active && priceage.type === "extra")
            .forEach((priceage) => processPriceItem(priceage.price.price));
        }

        standard_priceages.forEach((priceage) => {
          processPriceItem(priceage.price.price);
        });
      }

      return;
    }
    if (!groupedPricesectionIds && !pricesectionIds) {
      pricesection.manualprices
        ?.filter(
          (manualprice) => manualprice.active && manualprice.showInPriceRange
        )
        .forEach((manualprice) => {
          processPriceItem(manualprice.price);
        });

      pricesection.priceages?.forEach((priceage) => {
        processPriceage(priceage);
      });

      return;
    }
  }

  priceschemes?.forEach((pricescheme) => {
    if (pricescheme.pricesections && pricescheme.active) {
      pricescheme.pricesections.forEach((pricesection) => {
        processPricesection(pricesection);
      });
    }
  });

  if (prices.length === 0) {
    return { min: 0, max: 0, isEmpty: true };
  }

  const max = prices[prices.length - 1][prices[prices.length - 1].length - 1];
  const min_array = prices.find((dollar) => dollar);
  const min = min_array?.find((cent) => cent !== undefined) ?? max;

  return { min, max };
}
